import{gql as e}from"graphql-tag";import{ConversationFragmentDoc as o,CoachFragmentDoc as r,MemberFragmentDoc as a,MessageFragmentDoc as n,MessageResourceFragmentDoc as s,MessageMeditationResourceFragmentDoc as t,MessageProgramResourceFragmentDoc as c}from"./fragments.generated.es.js";const i=e`
    query conversations($active: Boolean) {
  conversations(active: $active) {
    edges {
      cursor
      node {
        ...conversation
      }
    }
  }
}
    ${o}
${r}
${a}
${n}
${s}
${t}
${c}`;export{i as ConversationsDocument};
//# sourceMappingURL=conversationsQuery.generated.es.js.map
